export default __webpack_public_path__ + "static/media/gallery_00.fda4aff3.jpg";